module.exports = __webpack_public_path__ + "img/carrom-thumb.493feb0d.jpg";